/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./push-notifications');

window.Vue = require('vue');

window.events = new Vue();

window.flash = function (message) {
    window.events.$emit('flash', message);
};

import Vue from "vue";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options = {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
}

Vue.use(Toast, options);

import VueCurrencyFilter from 'vue-currency-filter'

Vue.use(VueCurrencyFilter,
    {
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: true
    }
);


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('back-button', require('./components/BackButton.vue').default);
Vue.component('order-page', require('./components/OrderPage.vue').default);
Vue.component('weekly-order-page', require('./components/WeeklyOrderPage.vue').default);
Vue.component('store-card', require('./components/StoreCard.vue').default);
Vue.component('code-assignment', require('./components/CodeAssignment.vue').default);
Vue.component('problem-assignment', require('./components/ProblemAssignment.vue').default);
Vue.component('handle-attachments', require('./components/HandleAttachments.vue').default);
Vue.component('minimal-attachments', require('./components/MinimalAttachments.vue').default);

Vue.component('coding-test', require('./components/CodingTest.vue').default);
Vue.component('upload-resume', require('./components/UploadResume.vue').default);
Vue.component('upload-doc', require('./components/UploadDoc.vue').default);
Vue.component('experience-detail', require('./components/ExperienceDetail.vue').default);


Vue.component('review-coder', require('./components/ReviewCoder.vue').default);
Vue.component('emr-selector', require('./components/EmrSelector.vue').default);

Vue.component('search-record', require('./components/SearchRecord.vue').default);


//widgets
Vue.component('flash', require('./components/Flash.vue').default);
Vue.component('affiliate-dashboard', require('./components/AffiliateDashboard.vue').default);

// ui
Vue.component('dropdown-link', require('./components/DropdownLink.vue').default);
Vue.component('dropdown', require('./components/Dropdown.vue').default);
Vue.component('dropdown-light', require('./components/DropdownLight.vue').default);
Vue.component('dropdown2', require('./components/Dropdown2.vue').default);

Vue.component('navigation', require('./components/Navigation.vue').default);

Vue.component('help-center', require('./components/HelpCenter.vue').default);

Vue.component('assignment-comment', require('./components/AssignmentComment.vue').default);

Vue.component('reopen-assignment', require('./components/ReopenAssignment.vue').default);
Vue.component('assignment-history', require('./components/AssignmentHistory.vue').default);
Vue.component('coder-settings', require('./components/CoderSettings.vue').default);
Vue.component('agency-notification-settings', require('./components/AgencyNotificationSettings.vue').default);
Vue.component('site-admin-notification-settings', require('./components/SiteAdminNotificationSettings.vue').default);
Vue.component('agency-settings', require('./components/AgencySettings.vue').default);
Vue.component('payout-history', require('./components/PayoutHistory.vue').default);
Vue.component('pending-payouts', require('./components/PendingPayouts.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Add Vue debug mode when not in production
if (process.env.NODE_ENV !== 'production') {
    Vue.config.devtools = true;
    Vue.config.debug = true;
    Vue.config.silent = false;
}

Vue.config.errorHandler = function (err, vm, info) {
    console.error('Vue Error:', err);
    console.error('Component:', vm);
    console.error('Error Info:', info);
};

window.addEventListener('error', function (event) {
    console.error('Global Error:', event.error);
});

const app = new Vue({
    el: '#app',
});
